import filterConstants from '../constants';

const reportsTimeMonth = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.reportsTimeMonth,
  properties: {
    [filterConstants.PROPERTY.gantt_id]: '',
    [filterConstants.PROPERTY.rangeDate]: '',
  },
});

export default reportsTimeMonth;
